import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

@Component({
    selector: 'msc-showroom-exhibit-switch-page',
    templateUrl: './showroom-exhibit-switch-page.component.html',
    styleUrls: ['./showroom-exhibit-switch-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitSwitchPageComponent {
    public form: FormGroup;

    constructor(
        private readonly fb: FormBuilder,
    ) { }

    ngOnInit(): void {
        this.form = this.getFormGroup();
    }

    /**
     * Get the form group
     */
    getFormGroup(): FormGroup {
        return this.fb.group({
            'coffee': new FormControl(true),
            'soda': new FormControl(true),
            'water': new FormControl(true),
        });
    }
}
